"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _cssConstants = _interopRequireDefault(require("../../../../../../targets/cord_sanofi/cssConstants.js"));

var _TextField = _interopRequireDefault(require("@material-ui/core/TextField"));

var _StoreComponent2 = _interopRequireDefault(require("../store/StoreComponent"));

var _Validations = require("../../validations/Validations");

var _GenericStore = require("../store/GenericStore");

var _reactI18next = require("react-i18next");

var _styles = require("@material-ui/core/styles");

var _DataStore = _interopRequireDefault(require("../../../../../KESI2/Stores/DataStore2"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var StyledTextField = (0, _styles.withStyles)({
  root: {
    padding: '10px 0',
    '& label.Mui-focused': {
      color: _cssConstants["default"].colors.buttonBackground
    },
    '& .MuiFormLabel-root': {
      maxWidth: 'calc(100% - 28px)'
    },
    '& .MuiInput-underline:after': {
      borderBottomColor: _cssConstants["default"].colors.buttonBackground,
      width: '90%'
    },
    '& .MuiOutlinedInput-root': {
      '& fieldset': {
        borderColor: _cssConstants["default"].colors.buttonBackground
      },
      '&.Mui-focused fieldset': {
        borderColor: _cssConstants["default"].colors.buttonBackground
      }
    }
  }
})(_TextField["default"]);

var Input = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(Input, _StoreComponent);

  var _super = _createSuper(Input);

  function Input(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Input);
    _this = _super.call(this, props);
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onChange", function (event) {
      var _this$props = _this.props,
          parentPath = _this$props.parentPath,
          block = _this$props.block;
      var dict = {};
      dict[parentPath + '/value'] = event.target.value;
      dict[parentPath + '/isEdited'] = true;
      dict[parentPath + '/isDirty'] = _this.getForPath(parentPath + '/initial', '') !== event.target.value;

      _GenericStore.dataStore.setValues(dict);

      (0, _Validations.validateField)(parentPath, _GenericStore.dataStore, block);
    });
    var _parentPath = _this.props.parentPath;

    _this.addStoresAndPathes([{
      store: _GenericStore.dataStore,
      pathes: [_parentPath]
    }]);

    var _dict = {};
    _dict[_parentPath + '/isValid'] = true;

    _GenericStore.dataStore.setValues(_dict);

    return _this;
  }

  (0, _createClass2["default"])(Input, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          parentPath = _this$props2.parentPath,
          block = _this$props2.block,
          t = _this$props2.t,
          classes = _this$props2.classes;
      var multiline = block.rows && block.rows > 1;
      var value = this.getForPath(parentPath + '/value', '');
      var isValid = this.getForPath(parentPath + '/isValid', true);
      var errorMessage = this.getForPath(parentPath + '/errorMessage', '');
      console.log('render input', block, value);

      if (!value && block.prefillPath) {
        value = _DataStore["default"].getElementByPathImmediately(block.prefillPath);
      }

      return /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement(StyledTextField, {
        id: this._id,
        name: this._id,
        fullWidth: true,
        value: value,
        onChange: this.onChange,
        label: t(block.label),
        helperText: !isValid && t(errorMessage),
        error: !isValid,
        multiline: multiline,
        rows: block.rows,
        type: block.hasOwnProperty('inputType') ? block.inputType : 'text'
      }));
    }
  }]);
  return Input;
}(_StoreComponent2["default"]);

_TextField["default"].propTypes = {};

var _default = (0, _reactI18next.withTranslation)('common')(Input);

exports["default"] = _default;